import React from 'react';
import loadable from '@loadable/component';
import {connect} from 'react-redux';
import {
    CACHE as LOADING_CACHE,
    placeholderFromType,
} from '../../common/loading';

const LoadableDestinationRefinements = loadable(() =>
    import(
        /* webpackChunkName: "destination-refinements" */
        './DestinationRefinements'
    )
);

const BaseDynamicDestinationRefinements = () => {
    const placeholder = placeholderFromType(DynamicDestinationRefinements); // eslint-disable-line no-use-before-define

    return <LoadableDestinationRefinements fallback={placeholder} />;
};

const withStore = connect(({abacus}) => ({abacus}));

const DynamicDestinationRefinements = withStore(
    BaseDynamicDestinationRefinements
);

DynamicDestinationRefinements.displayName = 'DynamicDestinationRefinements';

export default DynamicDestinationRefinements;

LOADING_CACHE.set(DynamicDestinationRefinements, {
    componentType: 'DynamicDestinationRefinements',
    placeholderType: 'Carousel',
});
